// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"23511":"700bfd596dacef8b","94106":"f6fdafce488993ac"}[chunkId] + ".css";
};